import React from 'react';
import { Input, InputGroup } from '@chakra-ui/react';
import { LuSearch } from 'react-icons/lu';

interface PropertySelectorSearchProps {
	totalProperties: number;
	searchQuery: string;
	onSearchChange: (q: string) => void;
	/**
	 * 'seamless' (default): borderless/transparent, reads as the top section of the
	 * desktop dropdown. 'pill': a fully rounded surface that anchors itself in the
	 * mobile drawer where there's no top divider to lean on.
	 */
	variant?: 'seamless' | 'pill';
}

/** Reusable search input for property selection UIs. See `variant` for the two looks. */
const PropertySelectorSearch: React.FC<PropertySelectorSearchProps> = (props) => {
	const { totalProperties, searchQuery, onSearchChange, variant = 'seamless' } = props;

	if (totalProperties <= 1) return null;

	const pill = variant === 'pill';

	return (
		<InputGroup
			w="full"
			minH={pill ? 12 : undefined}
			bg={pill ? 'surface.default' : undefined}
			border={pill ? '1px solid' : undefined}
			borderColor={pill ? 'border.default' : undefined}
			borderRadius={pill ? 'full' : undefined}
			pe={pill ? 3 : 0}
			// TODO: chakra-migration design — see PropertiesSearch: the retired `text.subtle` left this
			// glyph inheriting the field's colour rather than sitting back from it.
			startElement={<LuSearch size={18} />}
		>
			<Input
				placeholder="Search properties"
				value={searchQuery}
				onChange={(e) => onSearchChange(e.target.value)}
				border="none"
				borderRadius={pill ? 'full' : 0}
				bg="transparent"
				h={pill ? 12 : undefined}
				px={0}
				outline="none"
				_placeholder={{ color: 'fg.subtle' }}
				_focus={{ boxShadow: 'none', outline: 'none' }}
				_focusVisible={{ boxShadow: 'none', outline: 'none' }}
			/>
		</InputGroup>
	);
};

export default PropertySelectorSearch;
